// <auto-generated />
// This file was generated by Medfar's Pdf Mapping Inkscape extension.
// Don't change it directly as your change would get overwritten.
// For more info take a look at the extension README (Myle.PdfFormGenerator/InkscapeExtension/readme.md)
// and the pdf generator README(Myle.PdfFormGenerator/readme.md)

class OntarioObstetricalFileFieldLimits {
    public static Page1 = {
        AgeAtEstimatedDateOfBirth: { MaxChars: 8, MaxRows: 1 },
        AllergiesOrSensitivities: { MaxChars: 59, MaxRows: 1 },
        AlternativeContact: { MaxChars: 21, MaxRows: 1 },
        ApptSuiteUnitNumber: { MaxChars: 13, MaxRows: 1 },
        BuzzerNumber: { MaxChars: 11, MaxRows: 1 },
        CityTown: { MaxChars: 26, MaxRows: 1 },
        CompletedBy: { MaxChars: 49, MaxRows: 1 },
        ConceptionDetails: { MaxChars: 23, MaxRows: 1 },
        ContactPreferred: { MaxChars: 26, MaxRows: 1 },
        ContraceptiveType: { MaxChars: 15, MaxRows: 1 },
        CycleQ: { MaxChars: 4, MaxRows: 1 },
        EducationLevel: { MaxChars: 13, MaxRows: 1 },
        FamilyPhysicianOrPrimaryCareProvider: { MaxChars: 49, MaxRows: 1 },
        Language: { MaxChars: 22, MaxRows: 1 },
        MedicalHistory_Comments: { MaxChars: 936, MaxRows: 8 },
        MedicalHistory_GeneticHistoryOfGametes_EggDonor: { MaxChars: 15, MaxRows: 1 },
        MedicalHistory_GeneticHistoryOfGametes_EggDonorAge: { MaxChars: 7, MaxRows: 1 },
        MedicalHistory_GeneticHistoryOfGametes_SpermDonor: { MaxChars: 15, MaxRows: 1 },
        MedicalHistory_MentalHealthAndSubstanceUse_AnxietyGadScore: { MaxChars: 9, MaxRows: 1 },
        MedicalHistory_MentalHealthAndSubstanceUse_CigarettesPerDay: { MaxChars: 4, MaxRows: 1 },
        MedicalHistory_MentalHealthAndSubstanceUse_DepressionPhq2Score: { MaxChars: 9, MaxRows: 1 },
        MedicalHistory_MentalHealthAndSubstanceUse_DrinksPerWeek: { MaxChars: 4, MaxRows: 1 },
        MedicalHistory_MentalHealthAndSubstanceUse_LastDrinkWhen: { MaxChars: 9, MaxRows: 1 },
        MedicalHistory_MentalHealthAndSubstanceUse_TaceScore: { MaxChars: 9, MaxRows: 1 },
        Medications: { MaxChars: 58, MaxRows: 1 },
        MostResponsibleProviderSignature: { MaxChars: 24, MaxRows: 1 },
        NewbornCareProviderInCommunity: { MaxChars: 15, MaxRows: 1 },
        NewbornCareProviderInHospital: { MaxChars: 21, MaxRows: 1 },
        ObstetricalCounterAbortus: { MaxChars: 7, MaxRows: 1 },
        ObstetricalCounterGravida: { MaxChars: 6, MaxRows: 1 },
        ObstetricalCounterLivingChildren: { MaxChars: 7, MaxRows: 1 },
        ObstetricalCounterPreterm: { MaxChars: 7, MaxRows: 1 },
        ObstetricalCounterStillBirths: { MaxChars: 7, MaxRows: 1 },
        ObstetricalCounterTerm: { MaxChars: 7, MaxRows: 1 },
        ObstetricalHistory_BirthWeight: { MaxChars: 6, MaxRows: 1 },
        ObstetricalHistory_BreastfedDuration: { MaxChars: 8, MaxRows: 1 },
        ObstetricalHistory_ChildCurrentHealth: { MaxChars: 11, MaxRows: 1 },
        ObstetricalHistory_Comments: { MaxChars: 58, MaxRows: 1 },
        ObstetricalHistory_GestationWeeks: { MaxChars: 4, MaxRows: 1 },
        ObstetricalHistory_LabourLength: { MaxChars: 5, MaxRows: 1 },
        ObstetricalHistory_PlaceOfBirth: { MaxChars: 6, MaxRows: 1 },
        ObstetricalHistory_Sex: { MaxChars: 3, MaxRows: 1 },
        ObstetricalHistory_TypeOfBirth: { MaxChars: 7, MaxRows: 1 },
        ObstetricalHistory_YearMonth: { MaxChars: 5, MaxRows: 1 },
        Occupation: { MaxChars: 14, MaxRows: 1 },
        OntarioHealthInsurancePlanNumber: { MaxChars: 19, MaxRows: 1 },
        Opr1ChildDeathOrNeonatal: { MaxChars: 15, MaxRows: 1 },
        PartnerAge: { MaxChars: 5, MaxRows: 1 },
        PartnerEducationLevel: { MaxChars: 23, MaxRows: 1 },
        PartnerFirstName: { MaxChars: 28, MaxRows: 1 },
        PartnerLastName: { MaxChars: 29, MaxRows: 1 },
        PartnerOccupation: { MaxChars: 28, MaxRows: 1 },
        PatientFileNumber: { MaxChars: 20, MaxRows: 1 },
        PatientFirstName: { MaxChars: 35, MaxRows: 1 },
        PatientLastName: { MaxChars: 31, MaxRows: 1 },
        PlannedBirthAttendant: { MaxChars: 29, MaxRows: 1 },
        PlannedPlaceOfBirth: { MaxChars: 28, MaxRows: 1 },
        PostalCode: { MaxChars: 15, MaxRows: 1 },
        Province: { MaxChars: 17, MaxRows: 1 },
        RelationshipStatus: { MaxChars: 16, MaxRows: 1 },
        ReviewedBy: { MaxChars: 50, MaxRows: 1 },
        SexualOrientation: { MaxChars: 13, MaxRows: 1 },
        Signature: { MaxChars: 28, MaxRows: 1 },
        StreetAddress: { MaxChars: 41, MaxRows: 1 }
    };

    public static Page2 = {
        AdditionalInvestigations_Column1_Results: { MaxChars: 17, MaxRows: 1 },
        AdditionalInvestigations_Column1_Tests: { MaxChars: 20, MaxRows: 1 },
        AdditionalInvestigations_Column2_Results: { MaxChars: 19, MaxRows: 1 },
        AdditionalInvestigations_Column2_Tests: { MaxChars: 18, MaxRows: 1 },
        ExamComments: { MaxChars: 164, MaxRows: 4 },
        FamilyPhysicianOrPrimaryCareProvider: { MaxChars: 49, MaxRows: 1 },
        InitialLabInvestigations_AntibodyScreenResult: { MaxChars: 17, MaxRows: 1 },
        InitialLabInvestigations_BloodGroupAndRhesusResult: { MaxChars: 17, MaxRows: 1 },
        InitialLabInvestigations_ChlamydiaResult: { MaxChars: 17, MaxRows: 1 },
        InitialLabInvestigations_GeneralConditionGonorrheasResult: { MaxChars: 17, MaxRows: 1 },
        InitialLabInvestigations_HemoglobinResult: { MaxChars: 17, MaxRows: 1 },
        InitialLabInvestigations_HepatitisBSurfaceAntigenHBsAgResult: { MaxChars: 17, MaxRows: 1 },
        InitialLabInvestigations_HumanImmunodeficiencyVirusResult: { MaxChars: 17, MaxRows: 1 },
        InitialLabInvestigations_MeanCorpuscularVolumeResult: { MaxChars: 17, MaxRows: 1 },
        InitialLabInvestigations_PlateletsResult: { MaxChars: 17, MaxRows: 1 },
        InitialLabInvestigations_RubellaImmuneResult: { MaxChars: 17, MaxRows: 1 },
        InitialLabInvestigations_SyphilisResult: { MaxChars: 17, MaxRows: 1 },
        InitialLabInvestigations_UrineCultureAndSensitivityResult: { MaxChars: 17, MaxRows: 1 },
        LastPapTestResult: { MaxChars: 42, MaxRows: 2 },
        NewbornCareProviderInCommunity: { MaxChars: 15, MaxRows: 1 },
        NewbornCareProviderInHospital: { MaxChars: 21, MaxRows: 1 },
        ObstetricalCounterAbortus: { MaxChars: 7, MaxRows: 1 },
        ObstetricalCounterGravida: { MaxChars: 6, MaxRows: 1 },
        ObstetricalCounterLivingChildren: { MaxChars: 7, MaxRows: 1 },
        ObstetricalCounterPreterm: { MaxChars: 7, MaxRows: 1 },
        ObstetricalCounterStillBirths: { MaxChars: 7, MaxRows: 1 },
        ObstetricalCounterTerm: { MaxChars: 7, MaxRows: 1 },
        PatientFirstName: { MaxChars: 35, MaxRows: 1 },
        PatientLastName: { MaxChars: 31, MaxRows: 1 },
        PhysicalExam_BloodPressure: { MaxChars: 5, MaxRows: 1 },
        PhysicalExam_BodyMassIndex: { MaxChars: 3, MaxRows: 1 },
        PhysicalExam_Height: { MaxChars: 5, MaxRows: 1 },
        PhysicalExam_PrepregnancyWeight: { MaxChars: 3, MaxRows: 1 },
        PlannedBirthAttendant: { MaxChars: 29, MaxRows: 1 },
        PrenatalGeneticInvestigations_ScreeningOffered_AbnormalPlacentalBiomarkersResult: { MaxChars: 16, MaxRows: 1 },
        PrenatalGeneticInvestigations_ScreeningOffered_ChorionicVillusSamplingResult: { MaxChars: 16, MaxRows: 1 },
        PrenatalGeneticInvestigations_ScreeningOffered_FirstTrimesterScreeningResult: { MaxChars: 16, MaxRows: 1 },
        PrenatalGeneticInvestigations_ScreeningOffered_IntegratedPrenatalScreeningResult: { MaxChars: 16, MaxRows: 1 },
        PrenatalGeneticInvestigations_ScreeningOffered_MaternalSerumScreeningResult: { MaxChars: 16, MaxRows: 1 },
        PrenatalGeneticInvestigations_ScreeningOffered_NoninvasivePrenatalTestingResult: { MaxChars: 16, MaxRows: 1 },
        PrenatalGeneticInvestigations_ScreeningOffered_NuchalTranslucencyRiskAssessmentResult: { MaxChars: 16, MaxRows: 1 },
        PrenatalGeneticInvestigations_ScreeningOffered_OtherGeneticTestingResult: { MaxChars: 16, MaxRows: 1 },
        SecondAndThirdTrimesterLabInvestigations_BloodGroupAndRhesusResult: { MaxChars: 19, MaxRows: 1 },
        SecondAndThirdTrimesterLabInvestigations_FirstHourGlucoseChallengeTestResult: { MaxChars: 19, MaxRows: 1 },
        SecondAndThirdTrimesterLabInvestigations_HemoglobinResult: { MaxChars: 19, MaxRows: 1 },
        SecondAndThirdTrimesterLabInvestigations_PlateletsResult: { MaxChars: 19, MaxRows: 1 },
        SecondAndThirdTrimesterLabInvestigations_RepeatAntibodiesResult: { MaxChars: 19, MaxRows: 1 },
        SecondAndThirdTrimesterLabInvestigations_SecondHourGlucoseToleranceTestResult: { MaxChars: 19, MaxRows: 1 },
        Ultrasound_GestationalAge_1: { MaxChars: 7, MaxRows: 1 },
        Ultrasound_GestationalAge_12: { MaxChars: 7, MaxRows: 1 },
        Ultrasound_GestationalAge_13: { MaxChars: 7, MaxRows: 1 },
        Ultrasound_GestationalAge_2: { MaxChars: 7, MaxRows: 1 },
        Ultrasound_GestationalAge_3: { MaxChars: 7, MaxRows: 1 },
        Ultrasound_GestationalAge_LastRows: { MaxChars: 7, MaxRows: 1 },
        Ultrasound_Result_1: { MaxChars: 92, MaxRows: 1 },
        Ultrasound_Result_12: { MaxChars: 36, MaxRows: 1 },
        Ultrasound_Result_13: { MaxChars: 36, MaxRows: 1 },
        Ultrasound_Result_2: { MaxChars: 62, MaxRows: 1 },
        Ultrasound_Result_3_AnatomyScan: { MaxChars: 11, MaxRows: 1 },
        Ultrasound_Result_3_PlacentalLocation: { MaxChars: 10, MaxRows: 1 },
        Ultrasound_Result_3_SoftMarkers: { MaxChars: 19, MaxRows: 1 },
        Ultrasound_Result_LastRows: { MaxChars: 92, MaxRows: 1 }
    };

    public static Page3 = {
        AllergiesOrSensitivities: { MaxChars: 59, MaxRows: 1 },
        DiscussionTopics_Comments: { MaxChars: 234, MaxRows: 2 },
        FamilyPhysicianOrPrimaryCareProvider: { MaxChars: 49, MaxRows: 1 },
        Issues: { MaxChars: 45, MaxRows: 1 },
        Medications: { MaxChars: 58, MaxRows: 1 },
        NewbornCareProviderInCommunity: { MaxChars: 15, MaxRows: 1 },
        NewbornCareProviderInHospital: { MaxChars: 21, MaxRows: 1 },
        ObstetricalCounterAbortus: { MaxChars: 7, MaxRows: 1 },
        ObstetricalCounterGravida: { MaxChars: 6, MaxRows: 1 },
        ObstetricalCounterLivingChildren: { MaxChars: 7, MaxRows: 1 },
        ObstetricalCounterPreterm: { MaxChars: 7, MaxRows: 1 },
        ObstetricalCounterStillBirths: { MaxChars: 7, MaxRows: 1 },
        ObstetricalCounterTerm: { MaxChars: 7, MaxRows: 1 },
        PatientFirstName: { MaxChars: 35, MaxRows: 1 },
        PatientLastName: { MaxChars: 31, MaxRows: 1 },
        PlannedBirthAttendant: { MaxChars: 29, MaxRows: 1 },
        PlanOfManagementOrMedicationChangeOrConsultations: { MaxChars: 72, MaxRows: 1 },
        RecommendedImmuniprophylaxis_OtherPostPartumVaccineDiscussed: { MaxChars: 17, MaxRows: 1 },
        RecommendedImmuniprophylaxis_PertussisUpdateYear: { MaxChars: 5, MaxRows: 1 },
        Signature_Initials_1: { MaxChars: 23, MaxRows: 1 },
        Signature_Initials_2: { MaxChars: 23, MaxRows: 1 },
        Signature_Initials_3: { MaxChars: 23, MaxRows: 1 },
        Signature_Initials_4: { MaxChars: 23, MaxRows: 1 },
        Signature_Initials_5: { MaxChars: 23, MaxRows: 1 },
        SpecialCircumstances_SocialCircumstances: { MaxChars: 85, MaxRows: 1 },
        SubsequentVisits_BloodPresure: { MaxChars: 6, MaxRows: 1 },
        SubsequentVisits_Comments: { MaxChars: 41, MaxRows: 1 },
        SubsequentVisits_FetalHeartRate: { MaxChars: 6, MaxRows: 1 },
        SubsequentVisits_FetalMovement: { MaxChars: 6, MaxRows: 1 },
        SubsequentVisits_GestionalAge: { MaxChars: 7, MaxRows: 1 },
        SubsequentVisits_Initials: { MaxChars: 6, MaxRows: 1 },
        SubsequentVisits_PrepregnancyBMI: { MaxChars: 6, MaxRows: 1 },
        SubsequentVisits_PrepregnancyWeight: { MaxChars: 9, MaxRows: 1 },
        SubsequentVisits_Presentation: { MaxChars: 6, MaxRows: 1 },
        SubsequentVisits_SymphysisToFundalHeightCentimeters: { MaxChars: 6, MaxRows: 1 },
        SubsequentVisits_UrineProtein: { MaxChars: 6, MaxRows: 1 },
        SubsequentVisits_Weight: { MaxChars: 6, MaxRows: 1 }
    };

    public static Page4 = {
        PatientFirstName: { MaxChars: 35, MaxRows: 1 },
        PatientLastName: { MaxChars: 31, MaxRows: 1 },
        Resources_AnxietyScreeningTotalScore: { MaxChars: 3, MaxRows: 1 },
        Resources_DepressionScreeningTotalScore: { MaxChars: 3, MaxRows: 1 },
        Resources_EdinburghTotalScore: { MaxChars: 8, MaxRows: 2 },
        Resources_TAceScreeningTotalScore: { MaxChars: 3, MaxRows: 1 }
    };

    public static Page5 = {
        BabyCareProvider: { MaxChars: 53, MaxRows: 1 },
        BabyHealthConcerns: { MaxChars: 76, MaxRows: 1 },
        BabyName: { MaxChars: 36, MaxRows: 1 },
        FeedingConcerns: { MaxChars: 234, MaxRows: 2 },
        PatientFirstName: { MaxChars: 35, MaxRows: 1 },
        PatientLastName: { MaxChars: 31, MaxRows: 1 },
        Postnatal_BirthAttendant: { MaxChars: 40, MaxRows: 2 },
        Postnatal_BirthWeightInGrams: { MaxChars: 10, MaxRows: 1 },
        Postnatal_BladderFunction: { MaxChars: 45, MaxRows: 1 },
        Postnatal_BloodPressure: { MaxChars: 14, MaxRows: 1 },
        Postnatal_BowelFunction: { MaxChars: 45, MaxRows: 1 },
        Postnatal_CurrentMedications: { MaxChars: 234, MaxRows: 2 },
        Postnatal_DiscussionTopics_AdviceRegardingFuturePregnanciesAndRisksComments: { MaxChars: 66, MaxRows: 1 },
        Postnatal_DiscussionTopics_CommunityResourcesComments: { MaxChars: 66, MaxRows: 1 },
        Postnatal_DiscussionTopics_ContraceptionComments: { MaxChars: 66, MaxRows: 1 },
        Postnatal_DiscussionTopics_FamilyViolenceAndSafetyComments: { MaxChars: 66, MaxRows: 1 },
        Postnatal_DiscussionTopics_FutureModeOfBirthAndPregnancySpacingComments: { MaxChars: 66, MaxRows: 1 },
        Postnatal_DiscussionTopics_NutritionOrPhysicalActivityOrHealthyWeightComments: { MaxChars: 66, MaxRows: 1 },
        Postnatal_DiscussionTopics_OtherComments: { MaxChars: 66, MaxRows: 1 },
        Postnatal_DiscussionTopics_PelvicFloorExercisesComments: { MaxChars: 66, MaxRows: 1 },
        Postnatal_DiscussionTopics_PlanOfManagementOfSubstanceUseComments: { MaxChars: 66, MaxRows: 1 },
        Postnatal_DiscussionTopics_PreconceptionPlanningComments: { MaxChars: 66, MaxRows: 1 },
        Postnatal_DiscussionTopics_TransitionToParenthoodOrPartnerAdjustmentComments: { MaxChars: 66, MaxRows: 1 },
        Postnatal_EmotionalWellBeing: { MaxChars: 44, MaxRows: 1 },
        Postnatal_FamilySupportOrCommunityResources: { MaxChars: 29, MaxRows: 1 },
        Postnatal_GestationalAgeAtBirth: { MaxChars: 32, MaxRows: 2 },
        Postnatal_LastPapTestResult: { MaxChars: 89, MaxRows: 1 },
        Postnatal_LochiaOrMenses: { MaxChars: 45, MaxRows: 1 },
        Postnatal_NumberOfCigarettesPerDay: { MaxChars: 4, MaxRows: 1 },
        Postnatal_NumberOfDrinksPerWeek: { MaxChars: 4, MaxRows: 1 },
        Postnatal_NumberOfWeeksPostpartum: { MaxChars: 7, MaxRows: 1 },
        Postnatal_OtherImmunization: { MaxChars: 41, MaxRows: 1 },
        Postnatal_PerineumOrIncision: { MaxChars: 42, MaxRows: 1 },
        Postnatal_PhysicalExam_Comments: { MaxChars: 264, MaxRows: 4 },
        Postnatal_PostpartumDepressionScreen: { MaxChars: 23, MaxRows: 1 },
        Postnatal_PreDeliveryWeightInKg: { MaxChars: 5, MaxRows: 1 },
        Postnatal_PrePregnancyWeightInKg: { MaxChars: 5, MaxRows: 1 },
        Postnatal_PrimaryCareProvider: { MaxChars: 24, MaxRows: 1 },
        Postnatal_Relationship: { MaxChars: 49, MaxRows: 1 },
        Postnatal_SexualFunction: { MaxChars: 45, MaxRows: 1 },
        Postnatal_SignatureOfHealthcareProvider: { MaxChars: 117, MaxRows: 1 },
        Postnatal_TaceScore: { MaxChars: 4, MaxRows: 1 },
        Postnatal_WeightTodayInKg: { MaxChars: 5, MaxRows: 1 },
        PregnancyBirthIssuesRequiringFollowUp: { MaxChars: 59, MaxRows: 1 },
        ReviewOfBirth_Details: { MaxChars: 194, MaxRows: 2 }
    };
}

export { OntarioObstetricalFileFieldLimits };
